import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import JsonLd from "@/components/feature/JsonLd";
import CtaBanner from "@/components/feature/CtaBanner";
import useScrollReveal from "@/hooks/useScrollReveal";
import { clinicInfo, heroSlides } from "@/mocks/site";
import { doctors } from "@/data/doctors";
import AboutHero from "./sections/AboutHero";
import Story from "./sections/Story";
import WhyOrthospine from "./sections/WhyOrthospine";
import CarePhilosophy from "./sections/CarePhilosophy";
import MeetSpecialist from "./sections/MeetSpecialist";
import PatientJourney from "./sections/PatientJourney";
import InsideClinic from "./sections/InsideClinic";

export default function About() {
  useScrollReveal();

  return (
    <Layout>
      <Seo
        title="About Ortho Spine Care | Orthopaedic & Spine Clinic in Trichy"
        description="Learn about Ortho Spine Care, an orthopaedic and spine surgery practice in Srirangam, Trichy led by Dr. N. Ajit Kumar, Senior Consultant in Orthopaedic and Spine Surgery."
        path="/about"
        image={heroSlides[0].image}
      />
      <JsonLd
        id="ld-about"
        data={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "About Ortho Spine Care",
          url: "https://orthospine.care/about",
          mainEntity: {
            "@type": "MedicalClinic",
            name: clinicInfo.name,
            telephone: clinicInfo.phoneDisplay,
            address: {
              "@type": "PostalAddress",
              streetAddress: clinicInfo.addressLine1,
              addressLocality: clinicInfo.city,
              addressRegion: clinicInfo.region,
              postalCode: "620005",
              addressCountry: "IN",
            },
            employee: {
              "@type": "Physician",
              name: doctors[0].name,
              jobTitle: doctors[0].designation,
              medicalSpecialty: ["Orthopedic", "Spine Surgery"],
            },
          },
        }}
      />

      <AboutHero />
      <Story />
      <WhyOrthospine />
      <CarePhilosophy />
      <MeetSpecialist />
      <PatientJourney />
      <InsideClinic />

      <CtaBanner
        title="Have a question about your condition?"
        text="Our team is happy to help you understand your options and arrange a consultation with the specialist."
      />
    </Layout>
  );
}